<template>
    <div class="pass-login">
        <div id="pass-login-main" class="pass"></div>
    </div>
</template>
<script>
/**
 * @file pass.vue
 * @desc pass登录入口
 * @author baoleilei@baidu.com
 * @date 2019-9-25
 */
import {passportOrigin} from '../../../config/constant';
import {mapState} from 'vuex';
const passDomain = `${passportOrigin}/passApi/js/wrapper.js`;
const passCrossDomainUrl = location.protocol + '//' + location.host
    + (process.env.NODE_ENV === 'development' ? '/v3Jump.html' : '/pc/static/v3Jump.html');
// 登录成功后要跳转的地址，此 url 需要接入 casClient
let firmUrl = location.protocol + '//' + location.host + '/fp/account/index/lawyer-info-confirm?authToken=';
export default {
    name: 'PASS',
    data() {
        return {
            industry: 'law'
        };
    },
    components: {
    },
    computed: {
        ...mapState({
            ind: state => state.Industry.ind,
            isLogin: state => state.Menu.isLogin,
            userInfoStatus: state => state.Menu.userInfoStatus,
            userType: state => state.Menu.userType,
            firstApprove: state => state.Menu.firstApprove
        })
    },
    mounted() {
        // 加载passport 文档 http://wiki.baidu.com/display/cbase/UniformLogin
        if (+this.isLogin === 1) {
            window.location.href = firmUrl + (this.$route.query && this.$route.query.authToken || '');
            return;
        }
        this.passLogin();
        this.$wywLog.send({
            serverId: 17245,
            action: 'show',
            page: 'login',
            area: 'login-pv',
            isConfirmLogin: 1
        });
    },
    methods: {
        passLogin() {
            let script = document.createElement('script');
            const product = this.ind[this.industry].product;
            script.src = passDomain;
            document.body.appendChild(script);
            const firmGoBackUrl = firmUrl + (this.$route.query && this.$route.query.authToken || '');
            script.onload = () => {
                window.passport.use('login', {
                    tangram: true,
                    loginVersion: 'v5',
                    defaultCss: true
                }, function (magic) {
                    let passLogin = new magic.passport.login({
                        product: product,
                        loginType: 1,
                        loginMerge: true, // 是否合并
                        hasRegUrl: true, // 是否有注册链接
                        autosuggest: true, // 是否自动提示
                        hasPlaceholder: true, // 是否有placeholder
                        authsiteLogin: ['qzone', 'tsina', 'weixin'], // 第三方登录
                        u: firmGoBackUrl,
                        isPhone: false,
                        safeFlag: 0,
                        staticPage: passCrossDomainUrl,
                        mustVerify: 1,
                        composeTemplate: 1, // 左侧展示扫码登录，右侧展示其他登录
                        sms: 5 // 短信登录，配置5表示接入短信登录能力
                    });
                    passLogin.render('pass-login-main');
                });
            };
        }
    }
};
</script>
<style lang="less" scoped>
.pass-login {
    width: 800px;
    border: 1px solid #efefef;
    box-shadow: 1px 0 0 #efefef;
    border-radius: 16px;
    background: #fff;
    /deep/ span.pass-generalError {
        max-width: 200px;
        height: auto;
        min-height: 40px;
    }
}
</style>